export const API_URL = `${process.env.NEXT_PUBLIC_BACKEND_HOST}/biz_ticket/api/v1`
